import { api } from '@/api'
import type { Dashboard, DashboardView, LinkedinAccount } from '@/types/models'

function withWorkspace(workspaceId: string) {
  return { 'X-Workspace': workspaceId }
}

/**
 * The workspace dashboard (PRD Slice 12): campaign funnels, account
 * health, and the needs-attention feed, all read-only rollups of existing
 * state.
 */
export const dashboardApi = {
  show: (workspaceId: string, view: DashboardView = 'workspace'): Promise<Dashboard> =>
    api
      .get<{ data: Dashboard }>(`/api/dashboard?view=${view}`, withWorkspace(workspaceId))
      .then((r) => r.data),

  snoozeExportFreshness: (workspaceId: string, linkedinAccountId: string): Promise<LinkedinAccount> =>
    api
      .post<{ data: LinkedinAccount }>(
        `/api/linkedin-accounts/${linkedinAccountId}/export-freshness/snooze`,
        {},
        withWorkspace(workspaceId),
      )
      .then((r) => r.data),
}
